import { render, staticRenderFns } from "./ListPayment.vue?vue&type=template&id=36bbd98f"
import script from "./ListPayment.vue?vue&type=script&lang=js"
export * from "./ListPayment.vue?vue&type=script&lang=js"
import style0 from "./ListPayment.vue?vue&type=style&index=0&id=36bbd98f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports